import { v4 as uuid } from "uuid";

import ViewBase from "../view-base.view";
import LanguagesUtils from "../../utils/languages";
import DeactivationIMEISelloutModel from "../../models/deactivation-management/deactivation-imei-sellout.model";

export default function DeactivationIMEISelloutView() {
  ViewBase.call(this);

  const DEFAULT_DEACTIVATE_ITEM = {
    imei: '',
    reason: ''
  };
  const DEFAULT_DEACTIVATE_ITEMS = [structuredClone(DEFAULT_DEACTIVATE_ITEM)];
  const IMEI_SO_DEACTIVATION_TYPE = "IMEI_SO";

  let userAccess = false;
  let limitedDays = 0;
  let uploadedResult = null;

  let deactivateItems = structuredClone(DEFAULT_DEACTIVATE_ITEMS);

  const handleClickAddRow = () => {
    deactivateItems.push(structuredClone(DEFAULT_DEACTIVATE_ITEM));
  };

  const handleClickDownloadResultFile = (fileId, filename) => (e) => {
    this.showLoading();
    DeactivationIMEISelloutModel.downloadResult(fileId, filename)
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleClickSubmitButton = (e) => {
    if (!this.validateForm(e)) return false;

    this.showLoading();
    DeactivationIMEISelloutModel.deactivate(deactivateItems)
      .then((res) => {
        uploadedResult = res;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleClickReset = () => {
    deactivateItems = structuredClone(DEFAULT_DEACTIVATE_ITEMS);
  };

  const handleInit = () => {
    this.showLoading();
    DeactivationIMEISelloutModel.checkAccess(IMEI_SO_DEACTIVATION_TYPE)
      .then((accessRes) => {
        userAccess = accessRes === 'Y';
        if (userAccess) {
          return DeactivationIMEISelloutModel.getBackDayLimit(IMEI_SO_DEACTIVATION_TYPE)
            .then((backDaysRes) => {
              limitedDays = backDaysRes
            })
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }


  return {
    oninit: handleInit,
    view: () => {
      return [
        m(".card.mb-3",
          m(".card-body",
            userAccess
              ? m('form.needs-validation[novalidate]', { onsubmit: handleClickSubmitButton },
                m('div',
                  m("span",
                    m("span.text-danger.fs-5", this.getText("LT00000930", "Disclaimer")),
                    m("span.text-danger.fs-5", ":")
                  ),

                  m(".mt-1.fs-5",
                    m('span.me-1', "*"),
                    m("span.me-2", LanguagesUtils.replacePlaceholder(
                      this.getText("LT00000932", "You are only allowed to deactivate ${$.A} of which sales date occurred in the past ${$.B} day(s)."),
                      {
                        "${$.A}": "sellout",
                        "${$.B}": limitedDays
                      }
                    )
                    )
                  )
                ),

                !uploadedResult &&
                m('.mt-4',
                  m('div',
                    m("button.btn.btn-primary", { type: 'button', onclick: handleClickAddRow },
                      m("i.bi.bi-plus.me-0"),
                      m('span', this.getText("LT00000907", "Row")))
                  ),
                  m(".mt-2",
                    m(".row.mx-0",
                      m(".col-12.p-0",
                        m(".table-responsive",
                          m("table.table",
                            m("thead.thead-bggrey",
                              m("tr.align-middle",
                                m("th[scope=col]", this.getText("LT00000948", "IMEI/Serial NO")),
                                m("th[scope=col]", this.getText("LT00000949", "Deactivation Reason")),
                              )
                            ),
                            m("tbody",
                              deactivateItems.map((item) => {
                                return m("tr",
                                  m("td",
                                    m('.position-relative',
                                      m('input.form-control.form-control-bg', {
                                        type: 'text',
                                        value: item.imei,
                                        required: true,
                                        onchange: (e) => { item.imei = e.target.value }
                                      }),
                                      m('.invalid-tooltip', this.getText('LT00000729', 'This field is required'))
                                    )
                                  ),
                                  m("td",
                                    m('.position-relative',
                                      m('input.form-control.form-control-bg', {
                                        type: 'text',
                                        value: item.reason,
                                        required: true,
                                        onchange: (e) => { item.reason = e.target.value }
                                      }),
                                      m('.invalid-tooltip', this.getText('LT00000729', 'This field is required'))
                                    ),
                                  ),
                                );
                              })
                            )
                          )
                        ),
                      )
                    )
                  ),
                  m(".text-end.p-2",
                    m("button.btn.btn-primary", this.getText("LT00000005", "Submit")),
                    m("button.btn.btn-primary.ms-1.m-sm-3", {
                      type: 'button',
                      onclick: handleClickReset
                    }, this.getText("LT00000006", "Reset"))
                  ),
                ),

                uploadedResult &&
                m(".mt-4",
                  m(".mt-2",
                    m("span", `${this.getText("LT00000934", "Total Record(s) Deactivated")}: `),
                    m("span", uploadedResult?.successCount),
                    m("span.ms-3[role=button]", { onclick: handleClickDownloadResultFile(uploadedResult?.successFileGUID, `deactivated_${uploadedResult?.successFileGUID}`) }, this.getText("LT00000935", "Download File"))
                  ),
                  m(".mt-2",
                    m("span", `${this.getText("LT00000795", "Total Record(s) Rejected")}: `),
                    m("span.text-danger", uploadedResult?.rejectedCount),
                    m("span.ms-3[role=button]", { onclick: handleClickDownloadResultFile(uploadedResult?.rejectedFileGUID, `rejected_${uploadedResult?.rejectedFileGUID}`) }, this.getText("LT00000935", "Download File"))
                  ),

                  uploadedResult?.failRecords?.length > 0 &&
                  m(".table-responsive.mt-2",
                    m("table.table.align-middle", [
                      m("thead",
                        m("tr", [
                          m("th[scope=col]", this.getText("LT00000948", "IMEI/Serial No")),
                          m("th[scope=col]", this.getText("LT00000748", "Model Code")),
                          m("th[scope=col]", this.getText("LT00000949", "Deactivation Reason")),
                          m("th[scope=col]", this.getText("LT00000015", "Status")),
                        ])
                      ),
                      m("tbody", [
                        uploadedResult?.failRecords?.map((item) =>
                          m("tr", [
                            m("td", item.imei),
                            m("td", item.modelCode),
                            m("td", item.deactivationReason),
                            m("td", item.remarks),
                          ])
                        ),
                      ]),
                    ])
                  )
                )
              )
              : m('.text-center', 'You are NOT authorized to access to IMEI/Serial Number Deactivation function!!')
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}